import TemplateView from "../../../TemplateView"
import {formatFmlWithCheck} from "../../../util/UserNameFormat"
import CopyUserSelector from "../../../administration/userManagement/CopyUserSelector"
import CopySettingsFromButton from "../../../administration/userManagement/CopySettingsFromButton"
import messageResource from "../../../messageResource"

export default class Header extends TemplateView
{
    constructor({
        onCopyUserSelectionCallback = () => {},
        onCloseCallback = () => {},
    })
    {
        super(null);

        this.state = {
            firstName: '',
            lastName: '',
            middleInitial: '',
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            ugrEnabled: false,
            tzgEnabled: false,
            copyUser: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false,
        }

        this.callbacks = {
            onCopyUserSelectionCallback,
            onCloseCallback,
        }

        this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial'], () => this._updateUsername())
        this.onAnyStatePropertyChanged(
            ['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled', 'copyUser', 'isURAEnabled', 'isBTYEnabled'],
            () => this._updateCopySelector()
        )
    }

    templateHtml()
    {
        return "<div class='header userPanel_panelHeader'>" +
               "<div class='closeButton hideButton_panelContainer'></div>" +
               "    <div class='userName nameInfo ellipsis'></div>" +
               "    <div class='tabs'>" +
               "        <div class='accountSettings'><span class='tabText'><%=accountSettingsTab%></span></div>" +
               "        <div class='permissions'><span class='tabText'><%=permissionsTab%></span></div>" +
               "    </div>" +
               "    <div class='copySettingPlaceholder'/>" +
               "    <div class='spinner'/>" +
               "</div>"
    }

    messageKeys()
    {
        return {
            accountSettingsTab: "user.panel.header.tabs.account",
            permissionsTab: "user.panel.header.tabs.permissions",
            deleteButton: "user.panel.header.delete",
        }
    }

    afterRender()
    {
        this.$userName = this.find('.userName');
        this.$accountSettingsTab = this.find('.accountSettings');
        this.$permissionsTab = this.find('.permissions');
        this.$closeButton = this.find('.closeButton')

        this.copyUserSelector = new CopyUserSelector({
            title: messageResource.getMessage("user.add.js.copy_setting.selector.label"),
            selectionCallback: (selectedUser) => {
                this.copyAccountButton.setState({selectedUser: selectedUser})
                this.copyUserSelector.hide()
                this.callbacks.onCopyUserSelectionCallback(selectedUser.id)
            },
            showPermissionIcons: true,
            renderTo: this.$el,
        }).init()

        this.copyAccountButton = new CopySettingsFromButton().init(this.find(".copySettingPlaceholder"));
        this.copyAccountButton.bindClick(() => this.copyUserSelector.showAt(this.copyAccountButton.$el, "tr-br"));

        this.$closeButton.click(this.callbacks.onCloseCallback)
    }

    _updateUsername(){
        let nameInfo = messageResource.getMessage('user.add.js.new')
        if (this.state.firstName || this.state.lastName) {
            nameInfo += ': ' + formatFmlWithCheck({
                firstName: this.state.firstName,
                middleInitial: this.state.middleInitial,
                lastName: this.state.lastName,
            })
        }
        this.$userName.text(nameInfo);
    }

    _updateCopySelector() {
        this.copyAccountButton.setState({
            selectedUser: this.state.copyUser,
        })

        this.copyUserSelector.setState({
            users: this.state.users,
            userGroups: this.state.userGroups,
            timeZoneGroups: this.state.timeZoneGroups,
            ugrEnabled: this.state.ugrEnabled,
            tzgEnabled: this.state.tzgEnabled,
            isURAEnabled: this.state.isURAEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
            isTTAEnabled: this.state.isTTAEnabled,
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/Header.js